import React from "react";
import { Typography } from "@mui/material";
import { Block, CheckCircle, Done } from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import { ContentLayout } from "./ContentLayout";
import { RightPart } from "./Rightpart";
import { StyledButton } from "./utilsUi";

export const SignOut = () => {
  const navigate = useNavigate();
  return (
    <ContentLayout>
      <RightPart>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "88vh",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <CheckCircle
              sx={{
                position: "absolute",
                bottom: "-0.3em",
                opacity: "0.2",
                fontSize: "5em",
              }}
            />
            <Typography
              sx={{
                ml: 0.5,
                color: "#6a6a6a",
                letterSpacing: "2px",
                fontSize: "1em",
              }}
              variant="p"
            >
              You Are Successfully SignedOut
            </Typography>
          </div>
          <div style={{ marginTop: "1.8em" }}>
            <Typography sx={{opacity: '0.5'}} variant="p">Login Again</Typography>
            <StyledButton onClick={() => navigate("/login")} variant="text">
              Login
            </StyledButton>
          </div>
        </div>
      </RightPart>
    </ContentLayout>
  );
};
